// extracted by mini-css-extract-plugin
export default {"host":"ExternalLink_host__GEZ2r"};